module.exports = "<p class=\"text-center login__text mb37\">\n    <strong translate=\"assistant_password_recovery\"></strong><br />\n    <span translate=\"report_your_need_for_password\"></span>\n</p>\n<button ui-sref=\"account.login\" class=\"btn btn-block login__btn mb32\" translate=\"return_to_login\"></button>\n<div class=\"text-center mt10\">\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/account/components/reportSupervisor/reportSupervisor.html
// module id = 705
// module chunks = 0